<template>
  <section class="section section--grey">
    <div class="image-slider">
      <swiper ref="swiper" class="swiper" :options="swiperOption">
        <template v-for="slide in slides">
          <swiper-slide :key="slide.id">
            <div class="image-slide">
              <div class="image-outer">
                <v-image :image="slide.image"/>
              </div>
              <div class="description">
                <h2>{{ slide.title }}</h2>
                <p>{{ slide.description }}</p>
              </div>
            </div>
          </swiper-slide>
        </template>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
  </section>
</template>

<script>
import {
  Swiper,
  SwiperSlide,
  directive,
} from 'vue-awesome-swiper';

export default {
  name: 'image-slider',
  data() {
    return {
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 50,
        autoHeight: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    };
  },
  props: {
    slides: {
      type: Array,
    },
  },
  computed: {},
  methods: {},
  directives: {
    swiper: directive,
  },
  components: {
    vImage: () => import('@/components/image'),
    Swiper,
    SwiperSlide,
  },
};
</script>
